export default __webpack_public_path__ + "i18n/fr.ad9d1fa6e1b494d550f055bc48138085.json";